const people = [
  {
    name: 'Eduardo Goncalves',
    title: 'Customer Success and CEO',
    image: '/team/eduardo.jpg',
  },
  {
    name: 'Jeff Crawford',
    title: 'Strategy Advisor',
    image: '/team/jcrawford.jpg',
  },
  {
    name: 'Casey Brown',
    title: 'Customer Success, CTO and CSO',
    image: '/team/cbrown.jpeg',
  },
  {
    name: 'Marcus Bourget',
    title: 'Customer Success Officer and Medicaid Expert',
    image: '/team/mbourg.jpeg',
  },
  {
    name: 'Maria Pacifico',
    title: 'Customer Success Officer and GTN Expert',
    image: '/team/mpaci.jpeg',
  },
  {
    name: 'Josh Gingerich',
    title: 'Chief Customer Success Officer and Pharma Expert',
    image: '/team/jging.jpeg',
  },
];

export default people;
